import AppTheme from 'docs/src/modules/components/AppTheme';
import Privacy from 'docs/src/pages/premium-themes/onepirate/Privacy';

export default function Page() {
  return (
    <AppTheme title="Onepirate theme - MUI" description="A onepirate theme">
      <Privacy />
    </AppTheme>
  );
}
